<template>
  <div class="sino-card" v-loading.fullscreen.lock="loading">
    <!-- 头部信息 -->
    <div v-if="noData == 'false'">
      <!-- 头部信息 -->
      <activityHeader
        :textList="textList"
        :textObj="textObj"
        type="3"
        :statusText="
          (status == 1 || responseType == '走步') && dealineFn()
            ? '已超过截止日期，无法提交！'
            : ''
        "
      />

      <!-- 提交方式 -->
      <div class="my-activity-type">
        <div>
          <img src="@/images/submit.png" />
          <span class="my-text-gray">提交方式</span>
          <span>{{ responseTypeName }}</span>
        </div>
        <div>
          <img src="@/images/deadline.png" />
          <span class="my-text-gray">截止日期</span>
          <span>{{ formatDate(responseDeadline) }}00</span>
        </div>
      </div>
      <!-- 0未开始1进行中2已结束 -->

      <!-- 走步 -->
      <!-- 拍照反馈 -->
      <div
        v-if="isRedirect == 0"
        :class="[
          isRewarded == '2'
            ? 'two-btn-row'
            : this.responsed == 1
            ? 'two-btn'
            : '',
        ]"
      >
        <div
          class="my-activity-foot"
          v-if="isRewarded != '2' && (status == 1 || responseType == '走步')"
        >
          <button type="primary" :disabled="disabledFn()" @click="toSubmit">
            {{ btnText }}
          </button>
        </div>
        <div v-if="this.responsed == 1" class="go-draw">
          <button type="primary" @click="goDraw">
            已获奖，去{{ isRewarded === "1" ? "领取" : "查看" }}
          </button>
        </div>
      </div>
      <div v-else>
        <div class="my-activity-foot" v-if="status == 1">
          <button type="primary" @click="goPath">进入参与活动</button>
        </div>
      </div>
    </div>
    <page-none v-if="noData == 'true'" />
  </div>
</template>

<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import activityHeader from "./component/activityHeader";
import activityConfig from "../../centralControl/utils/activityConfig";
import pageNone from "../../components/pageNone";
import moment from "moment";
export default {
  components: {
    activityHeader,
    pageNone,
  },
  data() {
    return {
      activityId: "",
      centralControlId: '',
      loading: true,
      activeSujectList: {
        photograph: "摄影",
        painting: "绘画",
        article: "征文",
      }, //活动科目
      textObj: {},
      textList: [],
      responseTypeObj: {
        photo: "图片上传",
        walk: "走步",
        video: "视频上传",
        word: "文档上传",
      },
      responseType: "", //提交方式
      responseTypeName: "", //提交方式
      isRedirect: "0",
      redirectUrl: "",
      endTime: "", //截止日期
      status: "", //活动状态
      btnText: "", //按钮文字
      responsed: "", //是否提交 0未提交1已提交
      noData: "", //页面接口返回错误标识
      responseDeadline: "", //截止日期
      isRewarded: "",
    };
  },
  mounted() {
    this.queryDetailFn();
  },
  methods: {
    disabledFn() {
      return this.dealineFn();
    },
    dealineFn() {
      var responseDeadline = this.responseDeadline;
      var currentDate = new Date().getTime();
      return currentDate > responseDeadline;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:");
    },
    // 详情
    queryDetailFn() {
      const { id } = this.$route.query;
      this.centralControl.axios.centralControl(
        "wxOLActivityDetails",
        (res) => {
          this.loading = false;
          const { data = {}, code } = res;
          if (code == 200) {
            this.noData = "false";
            let {
              id,
              startTime,
              endTime,
              activityCategory,
              creatorOfficeLevel,
              name,
              status,
              content,
              responseType,
              responsed,
              responseDeadline,
              isRedirect,
              redirectUrl,
              isRewarded
            } = data;
            this.activityId = id;
            this.centralControlId = creatorOfficeLevel;
            this.status = status;
            this.isRewarded = isRewarded;
            this.responseDeadline = responseDeadline;
            this.dealineFn();
            this.isRedirect = isRedirect || "0";
            this.redirectUrl = redirectUrl || "";
            // 起止时间
            startTime =
              startTime && startTime.split(" ") && startTime.split(" ")[0];
            endTime = endTime && endTime.split(" ") && endTime.split(" ")[0];
            let during = startTime + " 至 " + endTime;
            // 主办单位
            let levelObj = {
              1: "工会",
              2: "分会",
            };
            // 头部信息
            this.textList = [
              { label: "主办单位", value: levelObj[creatorOfficeLevel] },
              { label: "活动时间", value: during },
              { label: "活动类型", value: "线上活动", color: "#29BEBC" },
              { label: "活动科目", value: activityCategory },
            ];
            content = content
              .replace(new RegExp("&lt;", "g"), "<")
              .replace(new RegExp("&gt;", "g"), ">")
              .replace(new RegExp("&quot;", "g"), "");
            this.textObj = {
              title: name,
              status: status,
              statusName: activityConfig.statueObj[status],
              content: content,
            };
            this.responseTypeName = this.responseTypeObj[responseType];
            this.responseType = responseType;
            this.endTime = endTime;
            const text = {
              walk: "获取步数",
              photo: "反馈提交请点这里",
              video: "反馈提交请点这里",
              word: "反馈提交请点这里",
            };
            this.btnText = text[this.responseType];
            this.responsed = responsed;
            if (this.responsed == 1) this.btnText = "已提交";
          } else {
            this.noData = "true";
          }
        },
        { id }
      );
    },
    goPath() {
      var a = document.createElement("a");
      a.href = this.redirectUrl;
      a.click();
    },
    goDraw() {
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId: this.activityId,
          source: "me1",
          status: this.status,
          level: this.centralControlId,
        }
      });
    },
    // 跳转至反馈提交
    toSubmit() {
      if (this.responseType == "walk") {
        // 走步
        this.$router.push({
          path: "/gainSteps",
          query: {
            appId: localStorage.getItem("appId"),
          },
        });
      } else {
        // 拍照
        // if (this.responsed == 1) return;
        const { id } = this.$route.query;
        this.$router.push({
          path: "/feedSubmit",
          query: {
            id,
          },
        });
      }
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/theme.styl';

.my-activity-type {
  background: #FFF;
  margin-top: 10px;
  margin-bottom: 80px;

  div {
    line-height: 50px;
    margin-left: 15px;

    img {
      width: 18px;
    }
  }

  >div:nth-child(1) {
    border-bottom: 1px solid $border-gray;
  }

  .my-text-gray {
    color: $text-gray2;
    margin: 0 20px 0 8px;
    font-family: PingFang SC;
  }
}

.my-activity-foot {
  background: #FFF;
  width: 100%;
  height: 82px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    background: $main-bgColor;
    height: 55px;
    border-radius: 10px;
    color: #FFF;
    font-family: Noto Sans S Chinese;
    font-weight: 500;
    width: 90%;
  }

  button[disabled] {
    color: white !important;
    background: #CCC !important;
  }
}
.two-btn-row {
  width 100%;
  display: flex;
  justify-content: center;
  .my-activity-foot, .go-draw {
    left 0;
    width 100%;
    background-color: transparent
  }
  button {
    width: 45%;
  }
}
.two-btn {
  width 100%;
  display: flex;
  justify-content: space-between;
  .my-activity-foot, .go-draw {
    width 50%;
    background-color: transparent
  }
  button {
    width: 90%;
  }
}
.go-draw {
  width: 100%;
  height: 82px;
  position: fixed;
  bottom: 0px;
  left: 50%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    background: #169BD5;
    height: 55px;
    border-radius: 10px;
    color: #FFF;
    font-family: Noto Sans S Chinese;
    font-weight: 500;
  }

  button[disabled] {
    color: white !important;
    background: #CCC !important;
  }
}
</style>
